import React from 'react'
import {connect} from 'react-redux'


import '../styles/ScrollButton.css'


class ScrollButton extends React.Component{
	go(){
		const {currentAudioItem} = this.props
		this.context.messageList.scrollToMessage(currentAudioItem.props.message.id)
		this.props.dispatch({
			type: 'CLASSROOM_HIDE_SCROLL_BUTTON'
		})
	}

	render(){
		const {showScrollButton, currentAudioItem, showQuickGuide} = this.props
		if(!showScrollButton || !currentAudioItem || showQuickGuide)
			return null
		return <div className="classroom-scroll-button"
			onClick={this.go.bind(this)}>
			回到播放位置
		</div>
	}
}


ScrollButton.contextTypes = {
  messageList: React.PropTypes.object
};


export default connect((state) => ({
	showScrollButton: state.classroom.showScrollButton,
	currentAudioItem: state.messageList.currentAudioItem,
	showQuickGuide: state.classroom.showQuickGuide,
}))(ScrollButton)



// WEBPACK FOOTER //
// ./src/components/ScrollButton.js